import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { History } from 'history';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ConfirmDialog from '../ConfirmDialog';
import './style.scss';

interface Props {
    confirmable?: boolean;
    goBackPath?: string | History.LocationDescriptor<History.LocationState>;
    onClick?: Function;
    replaceHistory?: boolean;
}

const GoBackMenu: React.FC<Props> = ({ confirmable, goBackPath, onClick, replaceHistory }: Props) => {
    const history = useHistory();
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const [show, setShow] = useState(false);

    const handleGoBackPath = () => {
        if (!!goBackPath) {
            replaceHistory ? history.replace(goBackPath) : history.push(goBackPath);
        } else {
            history.goBack();
        }
    };

    const handleDialogLeftClick = () => {
        setShow(false);
        handleGoBackPath();
    };

    const goBack = (event: React.MouseEvent) => {
        event.preventDefault();
        onClick && onClick();

        if (confirmable) {
            setShow(true);
        } else {
            if (!!goBackPath) {
                replaceHistory ? history.replace(goBackPath) : history.push(goBackPath);
            } else {
                history.goBack();
            }
        }
    };

    return (
        <div className="go-back navbar navbar-expand sub-nav" id={Constants.CONTENT_GO_BACK_BAR_ID}>
            <ConfirmDialog
                content={strings.WANT_TO_PROCEED}
                icon={Constants.icons.REPORT_PROBLEM}
                leftButtonTitle={strings.NO}
                leftClick={() => setShow(false)}
                rightButtonTitle={strings.YES}
                rightClick={handleDialogLeftClick}
                show={show}
                title={strings.WARN_ON_DISCARD_CHANGES}
            />
            <div className="container justify-content-start">
                <div className="sub-nav__inner">
                    <a href="#" onClick={goBack}>
                        <span className="material-icons go-back__icon">{Constants.icons.CHEVRON_LEFT}</span>
                        {strings.GO_BACK}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default GoBackMenu;
